<ng-container *transloco="let t; prefix: 'shared.checkout.checkout-fail'">
    <main *ngIf="(order$ | async)" class="h-auto flex flex-col px-4 py-14 gap-10 md:flex-row justify-evenly lg:pl-[72px] lg:pr-[178px] lg:py-[72px]">
    	<div class="flex flex-col justify-center gap-10 md:w-[489px]">
    		<div class="self-stretch text-black text-7xl font-semibold">{{t('header')}}</div>
    		<div class="self-stretch h-24 flex-col justify-center items-start gap-4 flex">
    		<div class="self-stretch text-[#50575f] text-base font-normal">
    			{{t('tryAgainInfoText')}}
    		</div>
    		</div>
    		<div class="px-5 py-4 bg-primary-500 rounded-2xl self-start">
    			<button class="text-black text-base font-semibold" [localizedRouterLink]="['../']">
    				{{t('titles.tryAgain')}}
    			</button>
    		</div>
    		</div>
    	<div class="flex justify-end w-full lg:w-auto relative content-center items-center">
    		<img class="w-full md:w-[471px] md:h-[493.39px] lg:w-auto" src="./assets/img/checkout-fail.png"/>
    	</div>
    </main>
</ng-container>